import {Timeline, Row, Col, Tag} from "antd";
import {
    ExclamationCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
    SyncOutlined
} from "@ant-design/icons";
import {defaultExtractDate} from "../../../utils";
import "./DeviceFMHistoryComponent.css"

export default function DeviceFMHistoryComponent({data}) {
    const typeMap = {
        USING: {icon: <SyncOutlined spin/>, color: "blue", label: "Using"},
        LOST: {icon: <ExclamationCircleOutlined/>, color: "orange", label: "Lost"},
        BROKEN: {icon: <CloseCircleOutlined/>, color: "red", label: "Broken"},
        ZREPORT: {icon: <ClockCircleOutlined/>, color: "green", label: "Z-Report"},
    };

    // Safely get fiscal_modules or default to empty array
    const fiscalModules = data?.fiscal_modules || [];

    if (fiscalModules.length === 0) {
        return <p>No history found.</p>; // optional: show loading or empty message
    }

    return (
        <Timeline variant="filled" style={{width: '100%'}}>
            {fiscalModules.map((item) => {
                const formattedDate = item.expired_date ? defaultExtractDate(item.expired_date) : 'Not expired'
                const typeInfo = typeMap[item.substitution_type] || {
                    icon: <ClockCircleOutlined/>,
                    color: "gray",
                    label: item.substitution_type
                };

                return (
                    <Timeline.Item key={item.id} dot={typeInfo.icon}>
                        <Row className="device-fm-history__row" wrap align="middle" gutter={[8, 8]}>
                            <Col className="device-fm-history__date">
                                {formattedDate}
                            </Col>

                            <Col className="device-fm-history__content" flex="1">
                                <div className="device-fm-history__body">
                                    <Tag color={typeInfo.color} className="device-fm-history__tag">
                                        {typeInfo.icon} {typeInfo.label}
                                    </Tag>

                                    <span className="device-fm-history__module">{item.fiscal_module}</span>
                                </div>
                            </Col>
                        </Row>
                    </Timeline.Item>
                );
            })}
        </Timeline>
    );
}
